import React from 'react';
import { default as ReactModernDrawer } from 'react-modern-drawer';

import { makeStyles } from '@providers/Theme';

import { DrawerProps } from './types';

import 'react-modern-drawer/dist/index.css';

const useStyles = makeStyles(() => ({
  root: { zIndex: 10000 },
}));

export const Drawer: React.FC<DrawerProps> = ({ children, ...props }) => {
  const styles = useStyles();

  return (
    <ReactModernDrawer {...props} style={styles.root as React.CSSProperties}>
      {children}
    </ReactModernDrawer>
  );
};
